export const STATUS_IDS = {
  available: 1,
  sold: 2,
  reserved: 6,
  quarantine: 8
}
